const projectScopePathPattern = /^\/workspaces\/([^/]+)\/projects\/([^/]+)(\/.*)$/;

const projectScopedProductPathPrefixes = [
  '/execution-runs',
  '/uploads',
  '/results-files',
  '/suites',
  '/tests',
  '/reports',
  '/trends',
  '/releases',
  '/features',
  '/pipelines',
  '/stages',
  '/jobs',
  '/coverage-runs',
  '/coverage-directories',
  '/coverage-files',
] as const;

export type ProjectRouteScope = {
  workspaceSlug: string;
  projectSlug: string;
  childPath: string;
};

export const resolveProjectRouteScope = (pathname: string): ProjectRouteScope | null => {
  const match = projectScopePathPattern.exec(pathname);
  if (!match) return null;
  const workspaceSlug = match[1];
  const projectSlug = match[2];
  if (!workspaceSlug || !projectSlug) return null;
  return {
    workspaceSlug: decodeURIComponent(workspaceSlug),
    projectSlug: decodeURIComponent(projectSlug),
    childPath: match[3],
  };
};

export const stripProjectRouteScope = (pathname: string): string =>
  resolveProjectRouteScope(pathname)?.childPath ?? pathname;

export const isProjectScopedProductPath = (pathname: string): boolean => {
  const childPath = stripProjectRouteScope(pathname);
  return projectScopedProductPathPrefixes.some(
    (prefix) => childPath === prefix || childPath.startsWith(`${prefix}/`),
  );
};

export const buildProjectScopedPath = ({
  workspaceSlug,
  projectSlug,
  path,
}: {
  workspaceSlug: string;
  projectSlug: string;
  path: string;
}): string => {
  const childPath = stripProjectRouteScope(path);
  const normalisedChildPath = childPath.startsWith('/') ? childPath : `/${childPath}`;
  return `/workspaces/${encodeURIComponent(workspaceSlug)}/projects/${encodeURIComponent(
    projectSlug,
  )}${normalisedChildPath}`;
};
